import OMT_VILLAINS from '../../OMT_UI/OMT_Villains';

const width = 640;
const height = 1242;

const convertToPercentageX = (x) => (x / width) * 100;
const convertToPercentageY = (y) => (y / height) * 100;

const yOffset = 52;

export default [
  {
    texture: OMT_VILLAINS.getPrefixedName('villain_1_4'),
    landscape: {
      baseWidth: width,
      baseHeight: height,
      scaleCoeff: {
        scale: 1.5,
      },
    },
    transforms: [
      // Initial transform
      {
        x: convertToPercentageX(-64),
        y: convertToPercentageY(133 + yOffset),
        callback: (object) => {
          object.scale.setTo(0.45);
          object.scale.x *= -1;
        },
      },
      {
        x: convertToPercentageX(23),
        y: convertToPercentageY(101 + yOffset),
        duration: 200,
      },
      {
        x: convertToPercentageX(83),
        y: convertToPercentageY(148 + yOffset),
        duration: 200,
      },
    ],
  },
  {
    texture: OMT_VILLAINS.getPrefixedName('villain_2_1'),
    landscape: {
      baseWidth: width,
      baseHeight: height,
      scaleCoeff: {
        scale: 1.5,
      },
    },
    transforms: [
      // Initial transform
      {
        x: convertToPercentageX(704),
        y: convertToPercentageY(109 + yOffset),
        callback: (object) => {
          object.scale.setTo(0.45);
        },
      },
      {
        x: convertToPercentageX(640),
        y: convertToPercentageY(90 + yOffset),
        duration: 200,
      },
      {
        x: convertToPercentageX(544),
        y: convertToPercentageY(148 + yOffset),
        duration: 200,
      },
    ],
  },
  {
    texture: OMT_VILLAINS.getPrefixedName('super_hard_corruption'),
    destroyOnComplete: true,
    landscape: {
      scaleCoeff: {
        scale: 1.2,
      },
    },
    transforms: [
      // Initial transform
      {
        x: convertToPercentageX(314),
        y: convertToPercentageY(583),
        alpha: 0,
        scale: 1.98,
      },
      {
        wait: 400,
      },
      {
        alpha: 1,
        scale: 2.7,
        duration: 66,
      },
      {
        scale: 5.1,
        duration: 201,
      },
    ],
  },
  {
    texture: OMT_VILLAINS.getPrefixedName('super_hard_corruption'),
    destroyOnComplete: true,
    landscape: {
      scaleCoeff: {
        scale: 1.2,
      },
    },
    transforms: [
      // Initial transform
      {
        x: convertToPercentageX(318),
        y: convertToPercentageY(605),
        alpha: 0,
        angle: 90,
        scale: 1.95,
      },
      {
        wait: 400,
      },
      {
        wait: 99,
      },
      {
        alpha: 1,
        angle: 0,
        scale: 3.9,
        duration: 268,
      },
    ],
  },
];
